import { Component, Input, Host } from '@angular/core';
import { WidgetManagerComponent } from '../widget-manager.component';
import { WidgetPosition, WidgetConfig } from '../models/GIS-widget.models';

@Component({
    selector: 'widget-item',
    templateUrl: './widget.component.html',
    styleUrls: ['./widget.component.scss'],
    standalone: false
})
export class WidgetComponent {
    @Input()
    item: WidgetConfig;
    positions = Object.values(WidgetPosition);

    constructor(
        @Host() public _widgetManager: WidgetManagerComponent
    ) { }

    ngOnInit() {
    }

    delete() {
        this._widgetManager.deleteWidget(this.item);
    }
}
